import { useSelector } from 'react-redux';
import {
  selectActiveTemplate,
  selectLocationReportsFilter,
  selectSingleGeneralReport,
  selectFilterCriteriaData,
  selectAssetReportsFilter,
  selectGeneralReportsFilter,
  selectCreationFormData
} from 'pages/ReportLists/selectors';

export function useReportSelector() {
  const locationReportsFilter = useSelector(selectLocationReportsFilter());
  const assetReportsFilter = useSelector(selectAssetReportsFilter());
  const generalReportsFilter = useSelector(selectGeneralReportsFilter());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  const currentGeneralReport = useSelector(selectSingleGeneralReport());

  const activeTemplate = useSelector(selectActiveTemplate());
  const creationForm = useSelector(selectCreationFormData());

  return {
    creationForm,
    locationReportsFilter,
    assetReportsFilter,
    generalReportsFilter,
    currentGeneralReport,
    filterCriteria,
    activeTemplate
  };
}
